import { render, staticRenderFns } from "./account-info.vue?vue&type=template&id=4ec10d5a&scoped=true"
import script from "./account-info.vue?vue&type=script&lang=js"
export * from "./account-info.vue?vue&type=script&lang=js"
import style0 from "./account-info.vue?vue&type=style&index=0&id=4ec10d5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec10d5a",
  null
  
)

export default component.exports